export default "__VITE_ASSET__BiIxYsl9__"